let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7OCH8")).then(() => parcelRequire('2wveb'));